var _a, _b, _c, _d;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiCreateSpaceTag } from '@/infrastructure/api-functions/api-create-space-tag.interface';
import { ApiUpdateSpaceTag } from '@/infrastructure/api-functions/api-update-space-tag.interface';
import { ApiQuerySpaceTags } from '@/infrastructure/api-functions/api-query-space-tags.interface';
import { ApiDeleteSpaceTag } from '@/infrastructure/api-functions/api-delete-space-tag.interface';
let SpaceTagRepositoryImp = class SpaceTagRepositoryImp {
    constructor(_apiCreateSpaceTag, _apiUpdateSpaceTag, _apiQuerySpaceTags, _apiDeleteSpaceTag) {
        this._apiCreateSpaceTag = _apiCreateSpaceTag;
        this._apiUpdateSpaceTag = _apiUpdateSpaceTag;
        this._apiQuerySpaceTags = _apiQuerySpaceTags;
        this._apiDeleteSpaceTag = _apiDeleteSpaceTag;
    }
    async createSpaceTag(spaceTag) {
        const request = {
            label_name: spaceTag.tagName,
            type: spaceTag.type,
        };
        const response = await this._apiCreateSpaceTag.createSpaceTag(request);
        return {
            tagId: response.label_id,
            tagName: response.label_name,
        };
    }
    async updateSpaceTag(spaceTag) {
        const request = {
            label_id: spaceTag.tagId,
            label_name: spaceTag.tagName,
        };
        const response = await this._apiUpdateSpaceTag.updateSpaceTag(request);
        return {
            tagId: response.label_id,
            tagName: response.label_name,
        };
    }
    async querySpaceTags(data) {
        const request = {
            type: data.type,
        };
        const response = await this._apiQuerySpaceTags.querySpaceTags(request);
        return response.map(label => ({
            tagId: label.label_id,
            tagName: label.label_name,
        }));
    }
    async deleteSpaceTag(data) {
        const request = {
            label_id: data.tagId,
        };
        const response = await this._apiDeleteSpaceTag.deleteSpaceTag(request);
        return response;
    }
};
SpaceTagRepositoryImp = __decorate([
    injectable(),
    __param(0, inject(ApiCreateSpaceTag)),
    __param(1, inject(ApiUpdateSpaceTag)),
    __param(2, inject(ApiQuerySpaceTags)),
    __param(3, inject(ApiDeleteSpaceTag)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiCreateSpaceTag !== "undefined" && ApiCreateSpaceTag) === "function" ? _a : Object, typeof (_b = typeof ApiUpdateSpaceTag !== "undefined" && ApiUpdateSpaceTag) === "function" ? _b : Object, typeof (_c = typeof ApiQuerySpaceTags !== "undefined" && ApiQuerySpaceTags) === "function" ? _c : Object, typeof (_d = typeof ApiDeleteSpaceTag !== "undefined" && ApiDeleteSpaceTag) === "function" ? _d : Object])
], SpaceTagRepositoryImp);
export { SpaceTagRepositoryImp };
